import { useState } from 'react';

export const moveArray = <T>(array: T[], from: number, to: number): T[] => {
  const newArray = array.slice();
  newArray.splice(
    to < 0 ? newArray.length + to : to,
    0,
    newArray.splice(from, 1)[0],
  );

  return newArray;
};

export const useMergeState = <T extends Record<string, any>>(initial?: T) => {
  const [state, setState] = useState(initial);

  const merge = (valueOrCallback: Partial<T> | ((value: T) => Partial<T>)) => {
    setState((oldVal) => {
      const newVal =
        valueOrCallback instanceof Function
          ? valueOrCallback(oldVal)
          : valueOrCallback;

      return { ...oldVal, ...newVal };
    });
  };

  return [state, merge, setState] as const;
};

export const defaultReviews = [
  {
    name: 'Carrie',
    text: "Love this app!!! Every workout is challenging and I've had amazing results.",
  },
  {
    name: 'Laura',
    text: 'Beautiful, user friendly app. truly enjoying having quick access to workouts. makes reaching my goal of daily movement much easier.',
  },
  {
    name: 'Jess',
    text: 'Clear, strightforward, focused workouts that are enjoyable and effective.',
  },
];

export const defaultFaqs = [
  {
    question:
      'What makes Playbook different? How do I know it will work for me?',
    answer: `If you haven’t had success with other workout apps in the past, you may be skeptical about ours. But we’re here to tell you, we guarantee you’ll get the results you want with Playbook. Why? We have hundreds of experts who are ready to train you. We don’t give you one-off programs of PDF documents with no assistance. Our creators add new programs (with interactive, explanatory videos) on a daily basis. Our content is new, fresh, and ever-changing to keep you motivated and ready to work! Plus, if you need help,creators are always here for you. You can message them directly if you have any questions, feedback, or simply want to share your success.`,
  },
  {
    question: "I'm a beginner, is Playbook for me?",
    answer: `No matter where you are in your fitness journey, Playbook can help you succeed. Workouts and programs posted in the app are for any level of fitness. Plus, trainers walk you through all exercises with easy-to-follow videos and simple written instructions. This means you’ll be able to do all the moves easily, accurately, and safely.`,
  },
  {
    question: 'Do I need to purchase equipment?',
    answer: `It depends on the workout! Playbook has a lot of workouts that require no equipment. We also have workouts that require minimal equipment (like dumbbells or a yoga mat) and some that require weight-lifting machines. There’s something for everyone — regardless of equipment — to help you get in shape.`,
  },
];
